import {
  mdiAccount,
  mdiLogout,
  mdiWeatherNight,
  mdiWeatherSunny,
} from "@mdi/js";

export default [
  {
    icon: mdiWeatherNight,
    iconAlt: mdiWeatherSunny,
    label: "Modo oscuro",
    isDarkModeToggle: true,
  },
  {
    icon: mdiAccount,
    label: "Perfil",
    to: "/profile",
  },
  {
    isDivider: true,
  },
  {
    icon: mdiLogout,
    label: "Cerrar sesión",
    isLogout: true,
  },
];
